// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__8UdVJ","itemTitle":"ClientEmergencyInfo_itemTitle__1EDEb","itemText":"ClientEmergencyInfo_itemText__2yjAE"};